import { IFactoryMethod } from '@models/factory-method';

export function createMultiInstanceFactory<T>(factory: () => T): IFactoryMethod<T> {
    const castedFactoryMethod = factory as IFactoryMethod<T>;
    castedFactoryMethod.instanceType = 'multiInstance';
    return castedFactoryMethod;
}

type InstanceIdentifier = any;
let instanceMap = new WeakMap<InstanceIdentifier, any>();

export function createSingleInstanceFactory<T>(factory: () => T, identifier: InstanceIdentifier): IFactoryMethod<T> {
    const getInstance = (): T => instanceMap.get(identifier);
    const hasInstance = (): boolean => instanceMap.has(identifier);
    const setInstance = (instance: T) => instanceMap.set(identifier, instance);

    const wrappedFactory: IFactoryMethod<T> = () => {
        if (!hasInstance()) {
            setInstance(factory());
        }

        return getInstance();
    };
    wrappedFactory.instanceType = 'singleInstance';

    return wrappedFactory;
}

export function clearSingleInstances() {
    instanceMap = new WeakMap<InstanceIdentifier, any>();
}



// WEBPACK FOOTER //
// ./src/services/factory-instances.ts